<script setup lang="ts">
import SubmitButton from '@/components/forms/SubmitButton/SubmitButton.vue';
import { useNotificationStore } from '@/stores/notificationStore.ts';
import { useQaEquipmentStore } from '@/stores/qaEquipmentStore.ts';
import QaEquipmentRegistration from '@/views/qaEquipment/components/QaEquipmentRegistration.vue';
import { reloadEquipmentKey } from '@/views/qaEquipment/types.ts';
import { successfullyRegisteredMsg } from '@/views/qaEquipment/utils.ts';
import { useToggle } from '@vueuse/core';
import { inject, ref } from 'vue';
import { isRegistrablePtwQaEquipment } from '@/views/qaEquipment/utils';

const notificationStore = useNotificationStore();
const qaEquipmentStore = useQaEquipmentStore();

const reloadEquipment = inject(reloadEquipmentKey);

qaEquipmentStore.registrationSuccess = () => {
  if (
    qaEquipmentStore.deviceForRegistration &&
    isRegistrablePtwQaEquipment(qaEquipmentStore.deviceForRegistration)
  ) {
    notificationStore.success(successfullyRegisteredMsg(qaEquipmentStore.deviceForRegistration));
    qaEquipmentStore.setDeviceForRegistration(undefined);
  }
  reloadEquipment?.();
};
const isRegistrationDialogOpen = ref(false);
const toggleRegistrationDialog = useToggle(isRegistrationDialogOpen);
</script>

<template>
  <p class="text-body-2 font-weight-medium mb-2 text-primary">
    {{ $t('QaEquipmentRegistrationMsg') }}
  </p>
  <SubmitButton
    size="default"
    :loading="qaEquipmentStore.registrationPending"
    :text="$t('Register')"
    @click="toggleRegistrationDialog(true)"
  />
  <VDivider class="mt-5" />
  <QaEquipmentRegistration v-model="isRegistrationDialogOpen" />
</template>
